"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contains_1 = require("../utils/contains");
var getTagOfNode_1 = require("../utils/getTagOfNode");
var isNodeEmpty_1 = require("../utils/isNodeEmpty");
/**
 * Check if this position is at beginning of the given node.
 * This will return true if all nodes between the beginning of target node and the position are empty.
 * @param position The position to check
 * @param targetNode The node to check
 * @returns True if position is at beginning of the node, otherwise false
 */
function isPositionAtBeginningOf(position, targetNode) {
    if (position) {
        var _a = position.normalize(), node = _a.node, offset = _a.offset;
        if (offset == 0) {
            while (contains_1.default(targetNode, node) && areAllPreviousNodesEmpty(node)) {
                node = node.parentNode;
            }
            return node == targetNode;
        }
    }
    return false;
}
exports.default = isPositionAtBeginningOf;
function areAllPreviousNodesEmpty(node) {
    while (node.previousSibling) {
        node = node.previousSibling;
        if (getTagOfNode_1.default(node) == 'BR' || !isNodeEmpty_1.default(node)) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=isPositionAtBeginningOf.js.map